export default __webpack_public_path__ + "static/media/202.1830fa8d.png";